import { render, staticRenderFns } from "./LogoBar.vue?vue&type=template&id=5f8f819e&scoped=true"
import script from "./LogoBar.vue?vue&type=script&lang=js"
export * from "./LogoBar.vue?vue&type=script&lang=js"
import style0 from "./LogoBar.vue?vue&type=style&index=0&id=5f8f819e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8f819e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/b2bprionecokr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f8f819e')) {
      api.createRecord('5f8f819e', component.options)
    } else {
      api.reload('5f8f819e', component.options)
    }
    module.hot.accept("./LogoBar.vue?vue&type=template&id=5f8f819e&scoped=true", function () {
      api.rerender('5f8f819e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/header/type_6/LogoBar.vue"
export default component.exports